import { z } from "zod";
import { toObjectMap } from "../../utilities/dictionary";

const orderTypes = [
    "BOOKABLE",
    "BUYABLE",
    "MIXED",
    "VOUCHER",
    "GIFTCARD",
    "ACCOMMODATION",
] as const;
type OrderType = (typeof orderTypes)[number];
const orderType = toObjectMap<OrderType>([...orderTypes]);

const orderTypeZodSchema = z.enum(orderTypes);

export { orderType, orderTypeZodSchema, orderTypes };
export type { OrderType };
